(function ($) {
  'use strict';

  // Constants
  const BOX_PRICE = 189;
  const MONTHS_PER_YEAR = 12;
  const TIER_PERCENTAGES = {
    1: 0.13, // 13%
    2: 0.02, // 2%
    3: 0.01, // 1%
    4: 0.01  // 1%
  };

  // Calculator initialization
  function initCalculator() {
    const $calculatorSection = $('.meatzy-content-calculator');
    if (!$calculatorSection.length) return;

    const $directReferralsInput = $('#referrals');
    const $indirectReferralsInput = $('#referrals-by');

    // Calculate on input change
    $directReferralsInput.on('input', calculateEarnings);
    $indirectReferralsInput.on('input', calculateEarnings);

    // Initial calculation
    calculateEarnings();
  }

  function calculateEarnings() {
    const directReferrals = parseInt($('#referrals').val()) || 0;
    const indirectReferrals = parseInt($('#referrals-by').val()) || 0;

    // Calculate Year 1 base values
    const tier1Year1 = directReferrals * BOX_PRICE * TIER_PERCENTAGES[1] * MONTHS_PER_YEAR;
    const tier2Year1 = directReferrals * indirectReferrals * BOX_PRICE * TIER_PERCENTAGES[2] * MONTHS_PER_YEAR;
    const tier3Year1 = directReferrals * Math.pow(indirectReferrals, 2) * BOX_PRICE * TIER_PERCENTAGES[3] * MONTHS_PER_YEAR;
    const tier4Year1 = directReferrals * Math.pow(indirectReferrals, 3) * BOX_PRICE * TIER_PERCENTAGES[4] * MONTHS_PER_YEAR;
    
    const year1Earnings = tier1Year1 + tier2Year1 + tier3Year1 + tier4Year1;
    const tier234Sum = tier2Year1 + tier3Year1 + tier4Year1;

    // Store earnings for each year
    let yearEarnings = [];
    
    // Year 1
    yearEarnings[1] = year1Earnings;
    
    // Year 2 = Year 1 earnings × 2 + Tier 2-4 from Year 1
    yearEarnings[2] = (year1Earnings * 2) + tier234Sum;
    
    // Year 3 = Year 2 earnings + Year 1 earnings + 3 × (Tier 2-4)
    yearEarnings[3] = yearEarnings[2] + year1Earnings + (3 * tier234Sum);
    
    // Year 4 = Year 3 earnings + Year 1 earnings + 3 × (Tier 2-4)
    yearEarnings[4] = yearEarnings[3] + year1Earnings + (3 * tier234Sum);
    
    // Year 5 = Year 4 earnings + Year 1 earnings + 4 × (Tier 2-4)
    yearEarnings[5] = yearEarnings[4] + year1Earnings + (4 * tier234Sum);

    // Calculate grand total (sum of all years)
    let grandTotal = 0;
    for (let year = 1; year <= 5; year++) {
      grandTotal += yearEarnings[year];
      
      // Update display for each year
      const $yearAmount = $(`.calculator__amount[data-year="${year}"]`);
      $yearAmount.text(formatCurrency(yearEarnings[year]));
    }

    // Update total
    $('.calculator__total-amount').text(formatCurrency(grandTotal));
  }

  function formatCurrency(amount) {
    return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Initialize on document ready
  $(document).ready(function() {
    initCalculator();
  });

})(jQuery);
